// @flow

import React, { useMemo } from "react";
import { arrayMove } from "@dnd-kit/sortable";
import { DndContext, closestCenter } from "@dnd-kit/core";

import SortableList from "./SortableList";

type Props = {
  chartDetails: Object,
  setChartDetails: Function,
};

const Series = ({ chartDetails, setChartDetails }: Props) => {
  const series = chartDetails.series || [];

  const itemIds = useMemo(
    () => series.map((chart) => String(chart.seriesId || chart.tempId)),
    [series],
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const oldIndex = itemIds.indexOf(active.id);
    const newIndex = itemIds.indexOf(over.id);

    setChartDetails((prevChart) => {
      const series = prevChart.series;
      const updatedSeries = arrayMove(series, oldIndex, newIndex);
      return { ...prevChart, series: updatedSeries };
    });
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableList
        itemIds={itemIds}
        chartDetails={chartDetails}
        setChartDetails={setChartDetails}
      />
    </DndContext>
  );
};

export default Series;
